import { useQuery } from "@tanstack/react-query";

import { getAll } from '../services/planService';

const usePlanServices = () => useQuery({
    queryKey: ['plan-services'],
    queryFn: () => getAll().then(res => res.data),
    staleTime: 60 * 60 * 1000  // 1 hour
})

export default usePlanServices;